import React from 'react';
import cn from 'classnames';
import Image from 'next/image';
import { faLongArrowRight } from '@fortawesome/pro-regular-svg-icons';

import Link from '../Link/Link';

import styles from './RecommendedTopListItem.module.scss';
import Props from './RecommendedTopListItem.props';
import Card from '@components/ui/Card/Card';
import Button from '@components/ui/Button/Button';

const RecommendedTopListItem = ({ title, article, link, className }: Props) => {
  return (
    <div className={cn(styles.RecommendedTopListItem, className)}>
      <h2 className={styles.Title}>{title}</h2>
      <Card className={styles.Article}>
        <div className={styles.Thumbnail}>
          <div className={styles.ImageWrapper}>
            {!!article.thumbnail && (
              <Image src={article.thumbnail.medium} alt="" quality={60} layout="fill" />
            )}
          </div>
        </div>
        <div className={styles.Content}>
          <Link href={article.url}>
            <h1 className={styles.Title} data-testid="articleLink">
              {article.title}
            </h1>
          </Link>
          <p className={styles.Excerpt}>{article.excerpt}</p>
          <Button href={link.url} icon={faLongArrowRight} className={styles.ListLink}>
            {link.label}
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default RecommendedTopListItem;
